import type { ChatThreadCurrentUserStatusStatus } from './chatThreadCurrentUserStatusStatus';

export type ChatThreadCurrentUserStatus = {
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  invitedBy?: string | null;
  /** @nullable */
  requestedAt?: string | null;
  status: ChatThreadCurrentUserStatusStatus;
};
